import axios from "axios"

export const getAddress = async (zipcode) => {
  const { data } = await axios.get(`https://viacep.com.br/ws/${zipcode}/json/`);
  if(data.erro == "true")
    return false
  return data
}